<template>
  <div>
    <AdminHeader class="mx-5 mt-8" />
    <AdminListPanel class="mx-5 mt-8" />
  </div>
</template>

<script>
import AdminHeader from "@/components/organisms/Administrador/admin-header";
import AdminListPanel from "@/components/organisms/Administrador/admin-list-panel";

export default {
  components: { AdminHeader, AdminListPanel }
};
</script>

<style scoped>
</style>